import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleData } from '@/mocks/articles';

export default function ArticlePage() {
  const article = articleData['sugargoo-review-2026'];
  return <ArticleLayout article={article} />;
}